// extracted by mini-css-extract-plugin
export default {"date_picker":"MyDatePicker_date_picker__6mMf1","field_style":"MyDatePicker_field_style__WRkKT"};